import { cnMixCard } from '@consta/uikit/MixCard'
import { cnMixSpace } from '@consta/uikit/MixSpace'
import cn from 'classnames'

import css from './HeaderExpandablePopover.css'

export const internalClassName = cnMixCard({ border: true }, [css.container])

export const titleClassName = cn(cnMixSpace({ p: 's' }), css.header)
